import { buildAtlAttributionHeaders } from '@atlassian/search-client/atl-attribution';
import {
	fetchPastMeetingOccurrencesBatch,
	type PastMeetingOccurrencesBatchInput,
} from '@atlassian/search-client/past-meeting-occurrences/fetch';
import type { PastMeetingOccurrencesMap } from '@atlassian/search-client/past-meeting-occurrences/types';

export const fetchAndUpdatePastMeetingOccurrences = async (
	inputs: PastMeetingOccurrencesBatchInput[],
	cloudId: string | undefined,
	aggAbsoluteUrl: string | undefined,
	setPastOccurrences: React.Dispatch<React.SetStateAction<PastMeetingOccurrencesMap>>,
	logError: (error: unknown) => void,
): Promise<void> => {
	if (!cloudId || inputs.length === 0) {
		return;
	}

	// TWG workspace routing requires a site ARI as the queryContext
	const queryContext = `ari:cloud:platform::site/${cloudId}`;
	const headers = buildAtlAttributionHeaders({ cloudId });

	try {
		const result = await fetchPastMeetingOccurrencesBatch(inputs, queryContext, {
			aggAbsoluteUrl,
			headers,
		});
		setPastOccurrences((prev) => ({ ...prev, ...result }));
	} catch (e) {
		logError(e);
		// On failure, mark each ARI as null so the UI knows hydration was attempted but failed
		setPastOccurrences((prev) => {
			const updated = { ...prev };
			for (const input of inputs) {
				updated[input.videoAri] = null;
			}
			return updated;
		});
	}
};
